import type { FC } from 'react';
import React from 'react';
import { Body, Flex, Glyph, Pill } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import type {
  IconStyleType,
  QualityPillType,
} from '@/components/FlightSummary/AirlineQualityTag/QualityPill/config/types';
import { QualityTagType } from '@/components/FlightSummary/AirlineQualityTag/AirlineQualityTagCard/config/types';

const positiveIconStyle = {
  color: 'positive.50',
};

const negativeIconStyle = {
  color: 'warning.50',
};

const iconStyles: Record<QualityTagType, IconStyleType> = {
  positive: positiveIconStyle,
  negative: negativeIconStyle,
};

const QualityPill: FC<QualityPillType> = ({ type }) => {
  const { t } = useTranslation();

  const pillType = type === QualityTagType.positive ? 'positive' : 'warning';

  return (
    <Flex mb="1x_small">
      <Pill type={pillType} rounded theme="soft" data-testid="quality-pill">
        <Flex alignItems="center" gap="2x_small" sx={{ height: '28px' }}>
          <Glyph
            data-testid="quality-pill-icon"
            category="UIActions"
            name="Thumbsup"
            color={iconStyles[type].color}
            size="small"
            sx={{
              ...(type === QualityTagType.negative && {
                transform: 'rotate(180deg)',
              }),
            }}
          />
          <Body type="small">{t('results.qualitytag.retail.label')}</Body>
        </Flex>
      </Pill>
    </Flex>
  );
};

export default QualityPill;
